import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'legacy-packages/ft-cb';
import IDS from '../__tests__/ids';

import './styles.scss';

/**
 * The label to toggle the watched popover of an AP Daily video.
 * */
const PopoverLabel = ({ percentage }) => (
  <div
    className="watched-popover-label flex-vertical-align"
    data-test-id={IDS.POPOVER_LABEL}
  >
    <Icon
      className="person-icon"
      name="person"
      width="1.4rem"
      height="1.6rem"
    />
    <span data-test-id={IDS.POPOVER_LABEL_TEXT}>{percentage}% Watched</span>
    <Icon
      className="arrow-icon"
      name="menu_down"
      width="1.2rem"
      height="1.2rem"
    />
  </div>
);

PopoverLabel.displayName = 'PopoverLabel';

PopoverLabel.propTypes = {
  percentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

PopoverLabel.defaultProps = {
  percentage: 0,
};

export default PopoverLabel;
